module.exports = __webpack_public_path__ + "static/media/logo-rosa.0ad2b7d1.png";